import styles from "./RfqSampleTable.module.scss";

const RfqSampleTable = ({ samples }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getSourceDisplay = (source) => {
    const sourceMap = {
      syl_posted_orders: "Sylectus",
      dat_posted_orders: "DAT",
      load_link_posted_orders: "LoadLink",
    };
    return sourceMap[source] || source;
  };

  if (!samples || samples.length === 0) {
    return <p className={styles.noSamples}>No sample RFQs available.</p>;
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.headerCell}>Order #</th>
            <th className={styles.headerCell}>Customer</th>
            <th className={styles.headerCell}>Contact Email</th>
            <th className={styles.headerCell}>Pickup</th>
            <th className={styles.headerCell}>Delivery</th>
            <th className={styles.headerCell}>Miles</th>
            <th className={styles.headerCell}>Source</th>
            <th className={styles.headerCell}>Date</th>
          </tr>
        </thead>
        <tbody>
          {samples.map((sample, index) => (
            <tr key={sample.id || index} className={styles.dataRow}>
              <td className={styles.dataCell}>
                <span className={styles.orderNumber}>{sample.order_number}</span>
              </td>
              <td className={styles.dataCell}>
                <span className={styles.customerName} title={sample.customer_name}>
                  {sample.customer_name}
                </span>
              </td>
              <td className={styles.dataCell}>
                <span className={styles.contactEmail} title={sample.customer_contact_email}>
                  {sample.customer_contact_email}
                </span>
              </td>
              <td className={styles.dataCell}>
                <div className={styles.location}>
                  <span className={styles.city}>{sample.pick_up_city}</span>
                  <span className={styles.state}>{sample.pick_up_state}</span>
                </div>
              </td>
              <td className={styles.dataCell}>
                <div className={styles.location}>
                  <span className={styles.city}>{sample.delivery_city}</span>
                  <span className={styles.state}>{sample.delivery_state}</span>
                </div>
              </td>
              <td className={styles.dataCell}>
                <span className={styles.miles}>{sample.miles}</span>
              </td>
              <td className={styles.dataCell}>
                <span className={styles.source}>{getSourceDisplay(sample.source)}</span>
              </td>
              <td className={styles.dataCell}>
                <span className={styles.date}>{formatDate(sample.created_at)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RfqSampleTable;